import { Selector, State } from "./types";
import { Document, Identifiable } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveElementAttachmentsFailure(elementId) {
      const res = getState().find((result) => result.elementId === elementId);

      return res ? res.request.isFailure : false;
    },
    isRetrieveElementAttachmentsPending(elementId) {
      const res = getState().find((result) => result.elementId === elementId);

      return res ? res.request.isPending : false;
    },
    isRetrieveElementAttachmentsSuccess(elementId) {
      const res = getState().find((result) => result.elementId === elementId);

      return res ? res.request.isSuccessful : false;
    },
    hasRetrievedElementAttachments(elementId) {
      const res = getState().find((result) => result.elementId === elementId);
      return res ? res.request.isSuccessful || res.request.isFailure : false;
    },
    getAttachments(elementId): Identifiable<Document>[] {
      const res = getState().find((result) => result.elementId === elementId);
      return res ? res.attachments : [];
    },
  };
}

export { createSelector };
